import { ChangeEvent } from 'react';
import { Project } from '../service/backend-service';

function ProjectSelector({
  projects,
  onChange
}: {
  projects: Project[],
  onChange: (project? : Project) => void

}) {

    let changeHandler = (event : ChangeEvent<HTMLSelectElement>) : void => {
        if (event.target.value == null) {
            console.log("Returning null");
            onChange(undefined);
        } else {
            let idx = Number(event.target.value);
            onChange(projects[idx]);
        }
    };

  return (
    <select className={'form-select float-end header-select project-select'} onChange={changeHandler}>
        <option key="null">All</option>  
        {
          projects.map((project, index) => <option key={project.id} value={index}>{project.name}</option>)
        }
    </select>
  )
}

export default ProjectSelector;
